type ServiceConstantsProps = {
  backgroundImage: string;
  header: string;
  description: string;
  pillars: string[];
};

const SERVICES_CONSTANTS: ServiceConstantsProps = {
  backgroundImage: "bg2.jpg",
  header: "Services",
  description:
    "Tovani Hart offers a full range of architectural services for a wide variety of project types and sizes. We continue to deliver successful projects for our private and public sector clients. Thoughtful planning and design is, has been, and will continue to be a priority of Tovani Hart.",
  pillars: [
    "Architecture",
    "Planning",
    "Facility Assessments",
    "Feasibility Studies",
    "Construction Administration",
  ],
};

export default SERVICES_CONSTANTS;
